module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section-sponsors",
    attrs: {
      "id": "section-sponsors",
      "data-aos": "fade-up",
      "data-aos-once": "true",
      "data-aos-offset": "-200"
    }
  }, [_c('div-container', [_c('div', {
    staticClass: "columns is-gapless is-centered"
  }, [_c('div', {
    staticClass: "column has-text-centered item-wrapper"
  }, [_c('a', {
    attrs: {
      "href": "/about"
    }
  }, [_c('h2', {
    staticClass: "title"
  }, [_vm._v("\n            Official Partners\n          ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "columns is-gapless is-centered is-vcentered is-flex-mobile is-multiline"
  }, _vm._l((_vm.mnames), function(mname) {
    return (_vm.mitems[mname]) ? _c('div', {
      key: mname,
      staticClass: "column is-3 is-6-mobile has-text-centered item-wrapper"
    }, [(_vm.mitems[mname].link) ? _c('a', {
      staticClass: "item",
      attrs: {
        "href": _vm.mitems[mname].link,
        "target": "_blank"
      }
    }, [_c('img', {
      staticClass: "img-responsive",
      staticStyle: {
        "width": "100%",
        "max-width": "160px"
      },
      attrs: {
        "src": _vm.mitems[mname].image.path,
        "nopin": "nopin"
      }
    })]) : _c('a', {
      staticClass: "item",
      attrs: {
        "href": '/about?anchor=' + mname
      }
    }, [_c('img', {
      staticClass: "img-responsive",
      staticStyle: {
        "width": "100%",
        "max-width": "160px"
      },
      attrs: {
        "src": _vm.mitems[mname].image.path,
        "nopin": "nopin"
      }
    })])]) : _vm._e()
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "columns is-gapless is-centered"
  }, [_c('div', {
    staticClass: "column has-text-centered item-wrapper"
  }, [_c('a', {
    attrs: {
      "href": "/sponsors"
    }
  }, [_c('h2', {
    staticClass: "title"
  }, [_vm._v("\n            Sponsors\n          ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "columns is-gapless is-centered is-flex-mobile is-multiline"
  }, _vm._l((_vm.items), function(item) {
    return _c('div', {
      staticClass: "column is-3 is-6-mobile has-text-centered item-wrapper"
    }, [_c('a', {
      staticClass: "item",
      attrs: {
        "href": item.link,
        "target": "_blank"
      }
    }, [_c('img', {
      staticClass: "img-responsive",
      attrs: {
        "src": item.image.path
      }
    })])])
  }), 0)]), _vm._v(" "), _c('div-container', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('h4', {
    staticClass: "button is-primary"
  }, [_c('a', {
    attrs: {
      "href": "/sponsors"
    }
  }, [_vm._v("View All")])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a4cbf0ee","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/SponsorsSection.vue
// module id = 932
// module chunks = 1